import { useCallback, useMemo } from 'react';
import { useAppConfigContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { ICtaButtonConfig } from '@vivli/shared/infrastructure/interface';

export const useDisplayBannerHook = () => {
    const { bannerConfig } = useAppConfigContext();
    const { isAmr } = useAssignedAppTypeContext();

    const bannerButtonShouldDisplay = useCallback(
        (config: ICtaButtonConfig) => config && config.ctaButtonEnabled && config.ctaButtonText && config.ctaButtonUrl,
        []
    );

    const bannerTitleShouldDisplay = useCallback(
        () => bannerConfig && bannerConfig.bannerTitle && bannerConfig.bannerTitle.length > 0,
        [bannerConfig]
    );

    const bannerDescriptionShouldDisplay = useCallback(
        () => bannerConfig && bannerConfig.bannerDescription && bannerConfig.bannerDescription.length > 0,
        [bannerConfig]
    );

    const getNumberOfBannerButtonsPresent = useCallback((): number => {
        let numberOfButtons = 0;
        if (bannerButtonShouldDisplay(bannerConfig.ctaButtonOne)) {
            numberOfButtons++;
        }
        if (bannerButtonShouldDisplay(bannerConfig.ctaButtonTwo)) {
            numberOfButtons++;
        }
        return numberOfButtons;
    }, [bannerConfig, bannerButtonShouldDisplay]);

    const shouldDisplayBanner = useCallback((): boolean => {
        return (
            bannerConfig &&
            ((!isAmr && bannerConfig.displayBanner) || (isAmr && bannerConfig.displayBannerAmr)) &&
            (bannerTitleShouldDisplay() || bannerDescriptionShouldDisplay() || getNumberOfBannerButtonsPresent() > 0)
        );
    }, [bannerConfig, isAmr, bannerTitleShouldDisplay, bannerDescriptionShouldDisplay, getNumberOfBannerButtonsPresent]);

    const api = {
        shouldDisplayBanner,
        getNumberOfBannerButtonsPresent,
        bannerButtonShouldDisplay,
        bannerTitleShouldDisplay,
        bannerDescriptionShouldDisplay,
    };

    return useMemo(() => api, [api]);
};
